import { colorsPalette, styled } from '@lingoda/ui/theme';
import { ContentBlockTypography } from '@lingoda/content-blocks';

export const SubtitleContentBlockTypography = styled(ContentBlockTypography)({
    '& s': {
        color: colorsPalette.blackAlpha[30],
    },
});
